import { useState } from "react"
import classNames from "classnames"
import { FormProvider, useForm } from "react-hook-form"
import { formatNumber } from "@/lib/helpers/formatNumber"
import useCheckoutContext, {
  useActiveStep,
  usePaymentAmount,
  useFeeAmount,
  usePaymentMethod,
  useQuantity,
  useMembershipAmount
} from "../store"
import { PaymentForm } from "./paymentForm"
import { PaymentMethods } from "./paymentMethods"
import { SubmitForm } from "./submitForm"

function Payment(form) {
  const { paymentMethods } = useActiveStep()
  const { paymentMethod } = usePaymentMethod()
  const [orderResult, setOrderResult] = useState()
  const [showPaymentMethods, setShowPaymentMethods] = useState(true)
  const [showSummary, setShowSummary] = useState(true)
  const states = {
    orderResult,
    setOrderResult,
    showSummary,
    setShowSummary,
    showPaymentMethods,
    setShowPaymentMethods
  }

  const methods = useForm({
    defaultValues: {
      paymentMethod: paymentMethod ?? paymentMethods[0]?.value ?? null
    },
    mode: "all",
    shouldUnregister: true
  })

  return (
    <FormProvider {...methods} {...states}>
      {showSummary && (
        <Summary
          haveMembershipAmount={form.formSettings.haveMembershipAmount}
        />
      )}
      <PaymentForm orderSessionId={form.orderSessionId}>
        <div
          className={classNames({
            hidden: !showPaymentMethods || paymentMethods?.length === 1
          })}>
          <PaymentMethods
            orderSessionId={form.orderSessionId}
            states={states}
          />
        </div>

        {/* Current payment method */}

        <SubmitForm
          type={form.type}
          orderSessionId={form.orderSessionId}
          stepRef={form.stepRef}
          formSettings={form.formSettings}
        />
      </PaymentForm>
    </FormProvider>
  )
}

export function Terms() {
  const { terms: termsCopy } = useCheckoutContext()
  return (
    <label htmlFor="terms" className="flex cursor-pointer select-none mb-7">
      <div
        className="text-sm md:text-base wysiwyg-content"
        dangerouslySetInnerHTML={{ __html: termsCopy }}
      />
    </label>
  )
}

export function Summary({ haveMembershipAmount }) {
  const { membershipAmount } = useMembershipAmount()

  const {
    paymentAmount: { amountValue }
  } = usePaymentAmount()

  const { feeAmount } = useFeeAmount()

  const { summaryAmountLabel } = useActiveStep()
  const { quantity } = useQuantity()

  return (
    <div id="checkout-summary">
      <div className="flex items-center justify-between pb-3 mt-2 mb-6 border-b">
        {haveMembershipAmount && (
          <div className="flex flex-col w-full">
            <div className="flex justify-between w-full">
              <div>Medlemsavgift</div>
              <div>{formatNumber(membershipAmount)} kr</div>
            </div>

            {parseInt(amountValue) - parseInt(membershipAmount) !== 0 && (
              <div className="flex justify-between w-full">
                <div>Extra månadsgåva</div>
                <div>{formatNumber(amountValue - membershipAmount)} kr</div>
              </div>
            )}

            <div className="flex justify-between w-full pt-4 mt-4 border-t">
              <div>Ditt månadsbelopp</div>
              <div className="text-3xl font-bold">
                {formatNumber(amountValue)} kr
              </div>
            </div>
          </div>
        )}
        {!haveMembershipAmount && (
          <>
            <span className="text-lg">{summaryAmountLabel}</span>
            <span className="text-3xl font-bold">
              {formatNumber(feeAmount + amountValue * (quantity ?? 1))} kr
            </span>
          </>
        )}
      </div>
    </div>
  )
}

export default Payment
